module.exports = __webpack_public_path__ + "static/img/code.69cb9070.jpg";